import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MdSnackBar } from '@angular/material';
import { Version } from '../../models/Version';
import { Product } from '../../models/Product';
import { SoftwareService } from '../../shared/software.service';
import { AuthService } from '../../shared/auth.service';
import { MarkdownService } from 'angular2-markdown';

@Component({
    selector: 'version',
    providers: [AuthService],
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.css']
})
export class VersionComponent {
    releaseStatus = [
        ['Prototype', 0],
        ['Alpha', 1],
        ['Beta', 2],
        ['Internal', 3],
        ['Dealership', 4],
        ['Production', 5],
        ['Obsolete', 6]
    ];

    version: Version = new Version();
    products: Product[];

    busy: boolean = false;

    constructor(private softwareService: SoftwareService, public auth: AuthService, public snackBar: MdSnackBar, private route: ActivatedRoute) {
        let versionId = route.snapshot.params['id'];
        if (versionId > 0) {
            this.busy = true;
            this.getVersion(versionId);
        }
    }

    getVersion(id: number) {
        this.softwareService.getVersionById(id).subscribe(result => {
            this.version = result.json();

            this.softwareService.getProductsForVersion(this.version.Id).subscribe(result => {
                this.products = result.json();
                this.busy = false;
            }, err => {
                this.products = [];
                this.busy = false;
            });
        }, err => {
            this.busy = false;
            this.version = new Version();
            this.snackBar.open('Error loading version', null, { duration: 3000 });
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/containers/version/version.component.ts